import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, X, Users, Crown, UserPlus } from 'lucide-react';

// =====================================================================
// PLENARIUM:COMISSOES -- cadastro das comissoes da camara (admin).
// Cada camara cadastra as suas: nome, sigla, tipo e a composicao
// (Presidente, Vice-Presidente, Membros e Suplentes).
// =====================================================================

export const TIPO_COMISSAO = { PERMANENTE: 'Permanente', TEMPORARIA: 'Temporária', ESPECIAL: 'Especial', CPI: 'CPI' };
export const FUNCAO = { PRESIDENTE: 'Presidente', VICE_PRESIDENTE: 'Vice-Presidente', MEMBRO: 'Membro', SUPLENTE: 'Suplente' };
const VAZIO = { nome: '', sigla: '', tipo: 'PERMANENTE', descricao: '', ativa: true };
const SUGESTOES = [
  ['Comissão de Constituição, Justiça e Redação', 'CCJR'],
  ['Comissão de Finanças, Orçamento e Fiscalização', 'CFO'],
  ['Comissão de Educação, Saúde e Assistência Social', 'CESAS'],
  ['Comissão de Obras, Serviços Públicos e Meio Ambiente', 'COSPMA']
];

// PLENARIUM:COMISSOES_VISUAL
const CORES_COM = ['#2563eb', '#0d9488', '#7c3aed', '#c2410c', '#be185d', '#4d7c0f'];
const iniciaisC = (n) => String(n || '?').split(' ').filter(w => w && !['de', 'da', 'do', 'das', 'dos', 'e'].includes(w.toLowerCase())).map(x => x[0]).slice(0, 2).join('').toUpperCase() || '?';
function Foto({ m, t }) {
  return m.fotoUrl
    ? <img src={m.fotoUrl} alt="" style={{ width: t, height: t, borderRadius: '50%', objectFit: 'cover', objectPosition: 'top', flexShrink: 0 }} />
    : <span style={{ width: t, height: t, borderRadius: '50%', background: 'var(--cinza)', color: 'var(--texto-suave)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: t > 32 ? '.8rem' : '.62rem', fontWeight: 800, flexShrink: 0 }}>{iniciaisC(m.nome)}</span>;
}
const CSS_COM = `
.cmv-vazio { text-align: center; padding: 36px 24px !important; max-width: 920px; margin: 0 auto; }
.cmv-vazio-ic { width: 64px; height: 64px; border-radius: 18px; margin: 0 auto 12px; background: rgba(37,99,235,.12); color: var(--acento, #2563eb); display: flex; align-items: center; justify-content: center; }
.cmv-vazio h2 { font-size: 1.15rem; font-weight: 800; margin: 0 0 6px; color: var(--texto); }
.cmv-vazio p { font-size: .85rem; color: var(--texto-suave); max-width: 560px; margin: 0 auto; line-height: 1.5; }
.cmv-vazio-bts { display: flex; gap: 8px; justify-content: center; flex-wrap: wrap; margin: 18px 0 22px; }
.cmv-sug-tit { font-size: .7rem; font-weight: 800; letter-spacing: .8px; text-transform: uppercase; color: var(--texto-suave); margin-bottom: 10px; }
.cmv-sugs { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 10px; text-align: left; }
.cmv-sug { display: flex; align-items: center; gap: 10px; border: 1px solid var(--cinza); background: none; border-radius: 12px; padding: 10px 12px; cursor: pointer; font: inherit; color: var(--texto); transition: border-color .15s, box-shadow .15s; }
.cmv-sug:hover { border-color: var(--acento, #2563eb); box-shadow: 0 4px 14px rgba(15,23,42,.08); }
.cmv-sug-nome { flex: 1; text-align: left; font-size: .8rem; font-weight: 600; line-height: 1.35; }
.cmv-sug-mais { color: var(--texto-suave); flex-shrink: 0; }
.cmv-sigla { color: #fff; font-weight: 900; font-size: .72rem; border-radius: 10px; padding: 7px 8px; min-width: 48px; text-align: center; flex-shrink: 0; letter-spacing: .3px; }
.cmv-sigla.grande { width: 52px; height: 52px; min-width: 0; padding: 0; display: flex; align-items: center; justify-content: center; border-radius: 14px; }
.cmv-kpis { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; margin-bottom: 14px; }
.cmv-kpi { padding: 14px 16px !important; margin: 0 !important; }
.cmv-kpi b { display: block; font-size: 1.5rem; font-weight: 900; line-height: 1.1; color: var(--texto); }
.cmv-kpi small { font-size: .75rem; color: var(--texto-suave); font-weight: 600; }
.cmv-grade { display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 14px; }
.cmv-card { padding: 0 !important; margin: 0 !important; display: flex; flex-direction: column; overflow: hidden; border-top: 4px solid var(--cinza); }
.cmv-card.inativa { opacity: .6; }
.cmv-cab { display: flex; align-items: flex-start; gap: 12px; padding: 16px 18px 10px; }
.cmv-nome { font-weight: 800; font-size: .95rem; line-height: 1.3; color: var(--texto); }
.cmv-tags { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 5px; }
.cmv-tag { border: 1px solid var(--cinza); border-radius: 999px; padding: 1px 9px; font-size: .7rem; font-weight: 700; color: var(--texto-suave); }
.cmv-tag.alerta { border-color: #f59e0b; color: #b45309; background: rgba(245,158,11,.1); }
.cmv-desc { font-size: .78rem; color: var(--texto-suave); margin: 0 18px 8px; line-height: 1.45; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.cmv-corpo { flex: 1; padding: 4px 18px 14px; display: flex; flex-direction: column; gap: 6px; }
.cmv-semm { font-size: .8rem; color: var(--texto-suave); border: 1px dashed var(--cinza); border-radius: 10px; padding: 12px; text-align: center; }
.cmv-pres { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 12px; background: rgba(245,158,11,.1); border: 1px solid rgba(245,158,11,.3); margin-bottom: 4px; }
.cmv-pres small { display: flex; align-items: center; gap: 4px; font-size: .66rem; font-weight: 800; text-transform: uppercase; letter-spacing: .6px; color: #b45309; }
.cmv-pres b { display: block; font-size: .88rem; color: var(--texto); }
.cmv-pres span { font-size: .72rem; color: var(--texto-suave); }
.cmv-membro { display: flex; align-items: center; gap: 8px; font-size: .82rem; }
.cmv-m-nome { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--texto); font-weight: 600; }
.cmv-m-nome em { font-style: normal; font-weight: 500; color: var(--texto-suave); font-size: .74rem; }
.cmv-funcao { font-size: .68rem; font-weight: 800; border-radius: 999px; padding: 2px 8px; color: #1d4ed8; background: rgba(37,99,235,.1); flex-shrink: 0; }
.cmv-funcao.sup { color: var(--texto-suave); background: var(--cinza); }
.cmv-acoes { display: flex; align-items: center; gap: 6px; padding: 9px 14px; border-top: 1px solid var(--cinza); background: var(--cinza-claro, rgba(148,163,184,.06)); }
.cmv-link { display: inline-flex; align-items: center; gap: 5px; background: none; border: none; padding: 5px 8px; border-radius: 8px; font: inherit; font-size: .78rem; font-weight: 600; color: var(--texto-suave); cursor: pointer; }
.cmv-link:hover { background: var(--cinza); color: var(--texto); }
.cmv-link.perigo:hover { color: var(--reprovado); }
`;

export default function Comissoes() {
  const [lista, setLista] = useState([]);
  const [vereadores, setVereadores] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [modal, setModal] = useState(null);       // dados da comissao
  const [membros, setMembros] = useState(null);   // { comissao, lista: [{vereadorId, funcao}] }
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(async () => {
    try {
      const [c, v] = await Promise.all([axios.get('/api/comissoes'), axios.get('/api/vereadores')]);
      setLista(c.data || []); setVereadores((v.data || []).filter(x => x.ativo !== false));
    } catch { toast.error('Erro ao carregar as comissões'); }
    finally { setCarregando(false); }
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  const salvar = async (e) => {
    e.preventDefault(); setSalvando(true);
    try {
      if (modal.id) await axios.put(`/api/comissoes/${modal.id}`, modal);
      else await axios.post('/api/comissoes', modal);
      toast.success('Comissão salva!'); setModal(null); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  const remover = async (c) => {
    if (!window.confirm(`Remover a ${c.nome}?\n\nSe ela já tiver matérias no histórico, será apenas desativada.`)) return;
    try { const r = await axios.delete(`/api/comissoes/${c.id}`); toast.success(r.data?.message || 'Comissão removida'); carregar(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao remover'); }
  };

  const salvarMembros = async () => {
    setSalvando(true);
    try {
      await axios.put(`/api/comissoes/${membros.comissao.id}/membros`, { membros: membros.lista.filter(m => m.vereadorId) });
      toast.success('Composição salva!'); setMembros(null); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };
  const nomeV = (v) => (v ? (v.nomeParlamentar || v.nome) : '');
  // PLENARIUM:COMISSOES_VISUAL -- cadastra de uma vez as 4 sugeridas
  const criarSugeridas = async () => {
    if (!window.confirm('Cadastrar as 4 comissões sugeridas (CCJR, CFO, CESAS e COSPMA)? Depois é só ajustar nomes e membros.')) return;
    setSalvando(true);
    try { for (const [n, sg] of SUGESTOES) await axios.post('/api/comissoes', { ...VAZIO, nome: n, sigla: sg }); toast.success('Comissões cadastradas!'); carregar(); }
    catch (err) { toast.error(err.response?.data?.error || 'Erro ao cadastrar'); carregar(); }
    finally { setSalvando(false); }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Comissões</h1>
          <p className="page-subtitle">Comissões da Câmara, seus membros e as matérias em análise</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModal({ ...VAZIO })}><Plus size={15} /> Nova Comissão</button>
      </div>

      <style>{CSS_COM}</style>{/* PLENARIUM:COMISSOES_VISUAL */}
      {carregando ? <div className="loading-screen" style={{ minHeight: 200 }}><div className="spinner" /></div>
        : lista.length === 0 ? (
          <div className="card cmv-vazio">
            <div className="cmv-vazio-ic"><Users size={30} /></div>
            <h2>Nenhuma comissão cadastrada</h2>
            <p>As comissões analisam as matérias antes do plenário: o relator escreve o parecer pelo tablet e os membros votam. Cadastre as comissões previstas no Regimento Interno da Câmara.</p>
            <div className="cmv-vazio-bts">
              <button className="btn btn-primary" onClick={() => setModal({ ...VAZIO })}><Plus size={15} /> Nova comissão</button>
              <button className="btn btn-secondary" disabled={salvando} onClick={criarSugeridas}><Plus size={15} /> Cadastrar as 4 sugeridas</button>
            </div>
            <div className="cmv-sug-tit">Sugestões (comissões permanentes mais comuns)</div>
            <div className="cmv-sugs">
              {SUGESTOES.map(([n, s], i) => (
                <button key={s} className="cmv-sug" onClick={() => setModal({ ...VAZIO, nome: n, sigla: s })}>
                  <span className="cmv-sigla" style={{ background: CORES_COM[i % CORES_COM.length] }}>{s}</span>
                  <span className="cmv-sug-nome">{n}</span>
                  <Plus size={16} className="cmv-sug-mais" />
                </button>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="cmv-kpis">
              <div className="card cmv-kpi"><b>{lista.filter(c => c.ativa).length}</b><small>Comissões ativas</small></div>
              <div className="card cmv-kpi"><b>{new Set(lista.flatMap(c => c.membros.map(m => m.vereadorId))).size}</b><small>Vereadores em comissões</small></div>
              <div className="card cmv-kpi"><b style={{ color: lista.some(c => c.materiasAbertas > 0) ? '#d97706' : undefined }}>{lista.reduce((t, c) => t + (c.materiasAbertas || 0), 0)}</b><small>Matérias em análise</small></div>
            </div>
            <div className="cmv-grade">
              {lista.map((c, i) => {
                const cor = CORES_COM[i % CORES_COM.length];
                const pres = c.membros.find(m => m.funcao === 'PRESIDENTE');
                const outros = c.membros.filter(m => m.funcao !== 'PRESIDENTE');
                return (
                  <div key={c.id} className={`card cmv-card ${c.ativa ? '' : 'inativa'}`} style={{ borderTopColor: cor }}>
                    <div className="cmv-cab">
                      <span className="cmv-sigla grande" style={{ background: cor, fontSize: c.sigla && c.sigla.length > 4 ? '.7rem' : '.85rem' }}>{c.sigla || <Users size={20} />}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="cmv-nome">{c.nome}</div>
                        <div className="cmv-tags">
                          <span className="cmv-tag">{TIPO_COMISSAO[c.tipo] || c.tipo}</span>
                          {!c.ativa && <span className="cmv-tag">Desativada</span>}
                          {c.materiasAbertas > 0 && <span className="cmv-tag alerta">{c.materiasAbertas} matéria(s) em análise</span>}
                        </div>
                      </div>
                    </div>
                    {c.descricao && <p className="cmv-desc">{c.descricao}</p>}
                    <div className="cmv-corpo">
                      {c.membros.length === 0 ? <div className="cmv-semm">Sem membros definidos. Toque em <b>Membros</b> para montar a composição.</div> : (
                        <>
                          {pres && (
                            <div className="cmv-pres">
                              <Foto m={pres} t={40} />
                              <div style={{ flex: 1, minWidth: 0 }}><small><Crown size={11} /> Presidente</small><b>{pres.nome}</b><span>{pres.partido}</span></div>
                            </div>
                          )}
                          {outros.map(m => (
                            <div key={m.vereadorId} className="cmv-membro">
                              <Foto m={m} t={28} />
                              <span className="cmv-m-nome">{m.nome} <em>{m.partido}</em></span>
                              <span className={`cmv-funcao ${m.funcao === 'SUPLENTE' ? 'sup' : ''}`}>{FUNCAO[m.funcao]}</span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                    <div className="cmv-acoes">
                      <button className="btn btn-primary btn-sm" onClick={() => setMembros({ comissao: c, lista: c.membros.map(m => ({ vereadorId: m.vereadorId, funcao: m.funcao })) })}><UserPlus size={13} /> Membros</button>
                      <span style={{ flex: 1 }} />
                      <button className="cmv-link" onClick={() => setModal({ id: c.id, nome: c.nome, sigla: c.sigla || '', tipo: c.tipo, descricao: c.descricao || '', ativa: c.ativa })}><Pencil size={13} /> Editar</button>
                      <button className="cmv-link perigo" onClick={() => remover(c)}><Trash2 size={13} /> Remover</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto' }}>
            <div className="modal-header">
              <h2 className="modal-title">{modal.id ? 'Editar Comissão' : 'Nova Comissão'}</h2>
              <button className="btn-modal-close" onClick={() => setModal(null)}><X size={18} /></button>
            </div>
            <form onSubmit={salvar}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 140px', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Nome *</label>
                  <input className="form-input" value={modal.nome} onChange={e => setModal({ ...modal, nome: e.target.value })} placeholder="Comissão de Constituição, Justiça e Redação" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Sigla</label>
                  <input className="form-input" value={modal.sigla} onChange={e => setModal({ ...modal, sigla: e.target.value.toUpperCase() })} placeholder="CCJR" maxLength={12} />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo</label>
                  <select className="form-input form-select" value={modal.tipo} onChange={e => setModal({ ...modal, tipo: e.target.value })}>
                    {Object.entries(TIPO_COMISSAO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Situação</label>
                  <select className="form-input form-select" value={modal.ativa ? '1' : '0'} onChange={e => setModal({ ...modal, ativa: e.target.value === '1' })}>
                    <option value="1">Ativa</option><option value="0">Desativada</option>
                  </select>
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label className="form-label">Competência (opcional)</label>
                  <textarea className="form-input" rows={3} value={modal.descricao} onChange={e => setModal({ ...modal, descricao: e.target.value })} placeholder="O que a comissão analisa, conforme o Regimento Interno" />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {membros && (
        <div className="modal-overlay" onClick={() => setMembros(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto' }}>
            <div className="modal-header">
              <h2 className="modal-title">Membros — {membros.comissao.sigla || membros.comissao.nome}</h2>
              <button className="btn-modal-close" onClick={() => setMembros(null)}><X size={18} /></button>
            </div>
            <p style={{ fontSize: '0.75rem', color: 'var(--texto-suave)', marginBottom: 12 }}>O Presidente da comissão designa relatores e encerra a votação dos pareceres pelo tablet. Suplentes não votam.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {membros.lista.map((m, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <select className="form-input form-select" style={{ flex: 1 }} value={m.vereadorId} onChange={e => setMembros({ ...membros, lista: membros.lista.map((x, j) => (j === i ? { ...x, vereadorId: e.target.value } : x)) })}>
                    <option value="">Escolha o vereador</option>
                    {vereadores.filter(v => v.id === m.vereadorId || !membros.lista.some(x => x.vereadorId === v.id)).map(v => <option key={v.id} value={v.id}>{nomeV(v)} ({v.partido})</option>)}
                  </select>
                  <select className="form-input form-select" style={{ width: 160 }} value={m.funcao} onChange={e => setMembros({ ...membros, lista: membros.lista.map((x, j) => (j === i ? { ...x, funcao: e.target.value } : x)) })}>
                    {Object.entries(FUNCAO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => setMembros({ ...membros, lista: membros.lista.filter((x, j) => j !== i) })}><X size={13} /></button>
                </div>
              ))}
            </div>
            <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: 10 }} onClick={() => setMembros({ ...membros, lista: [...membros.lista, { vereadorId: '', funcao: membros.lista.length ? 'MEMBRO' : 'PRESIDENTE' }] })}><Plus size={13} /> Adicionar membro</button>
            <div className="modal-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setMembros(null)}>Cancelar</button>
              <button type="button" className="btn btn-primary" disabled={salvando} onClick={salvarMembros}>{salvando ? 'Salvando...' : 'Salvar composição'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
